import { Component, ErrorInfo, ReactNode } from "react"
import { useTranslation } from "react-i18next"
import * as Sentry from "@sentry/react"

interface Props {
  children: ReactNode
  widgetTitle?: string
}

interface State {
  hasError: boolean
}

function WidgetErrorFallback() {
  const { t } = useTranslation()
  return (
    <div className="WidgetErrorBoundary">
      <p className="WidgetErrorBoundary__message">{t("messages.failBasic")}</p>
    </div>
  )
}

/**
 * 개별 위젯을 격리하는 ErrorBoundary.
 * 위젯 하나에서 런타임 에러가 나도 다른 위젯과 홈 화면 전체는 계속 동작하도록 보호.
 * 에러는 Sentry로 리포트.
 */
export default class WidgetErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, {
      tags: { source: "home-widget" },
      extra: {
        widgetTitle: this.props.widgetTitle,
        componentStack: info.componentStack,
      },
    })
  }

  render() {
    if (this.state.hasError) {
      return <WidgetErrorFallback />
    }
    return this.props.children
  }
}
